import { AppIconsMapping, AppKeyMapping, IconProps, UUID } from '@umanforge/common';
import { DriveIcon } from 'components/icons/drive.icon';

export interface SearchApiResponse {
  total: number
  datas: FindedElementOnSearch[]
}

export type FindedElementOnSearch = ( ClBaseSearch | FmEventSearch | FmNoteSearch | FmDocSearch | PlActionSearch | RpTaskSearch | RpNoteSearch | RpDocSearch );

export type ApplicationSearchType = AppKeyMapping | 'CLOUD';

export const AppIconsSearch: Record<ApplicationSearchType, React.FC<Omit<IconProps, 'svg'>>> = {
  ...AppIconsMapping,
  CLOUD: DriveIcon
};

// Interface Commun
interface BaseSearchResult {
  id: UUID;
  index: number;
  application: ApplicationSearchType;
  type: TYPE_OF_SEARCH;
  accuracy: ACCURACY_RESPONSE
  clientName: string;
  clientId: string;
  siteName: string;
  siteId: string;
  sectorName: string | null;
  sectorId: string | null;
}
export enum TYPE_OF_SEARCH {
  TASK = 'task',
  NOTE = 'note',
  DOC = 'doc'
}
enum ACCURACY_RESPONSE {
  EXACT_PHRASE = 1,
  ALL_WORDS = 2,
  ANY_WORD = 3
}

// Interface Cloud
export interface ClBaseSearch extends BaseSearchResult {
  name: string;
  extension: string | null;
  description: string | null;
  path: string;
  elementCount: number | null;
}

// Interface Flashmeeting
interface FmBaseSearch extends BaseSearchResult {
  eventTitle: string;
  eventManagerName: string;
  eventManagerId: UUID;
}
export interface FmEventSearch extends FmBaseSearch {
  participantsFullname: string;
  deliveryDate: string;
  recurring: boolean;
  completed: boolean;
  archived: boolean;
  themeName: string;
  themeColor: string;
}
export interface FmNoteSearch extends FmBaseSearch {
  note: string;
  writeDate: string;
  authorFullname: string;
}
export interface FmDocSearch extends FmBaseSearch {
  name: string;
  path: string;
  extension: string;
}

// Interface Resolution
interface RpBaseSearch extends BaseSearchResult {
  rpId: UUID;
  rpTitle: string;
}
export interface RpTaskSearch extends RpBaseSearch {
  description: string;
  piloteFullname: string;
  detectedDate: string;
}
export interface RpNoteSearch extends RpBaseSearch {
  note: string;
  writeDate: string;
  authorFullname: string;
}
export interface RpDocSearch extends RpBaseSearch {
  name: string;
  description: string;
  path: string;
  extension: string;
}

// Interface Planiteam
interface PlBaseSearch extends BaseSearchResult {
  actionName: string;
}
export interface PlActionSearch extends PlBaseSearch {
  actionIcon: string;
  userFullname: string;
  taskStartDate: string;
  taskEndDate: string;
}